import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin } from "lucide-react";

const FOOTER_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Our Work", path: "/ourwork" },
  { label: "Team", path: "/team" },
  { label: "Contact", path: "/contact" },
];

const SERVICES = [
  { label: "Builder's Cleaning", slug: "builder-s-cleaning" },
  { label: "Industrial Cleaning", slug: "industrial-cleaning" }, 
  { label: "Facilities Management", slug: "facilities-management" },
  { label: "Office Cleaning", slug: "office-cleaning" },
  { label: "Deep Cleaning", slug: "deep-cleaning" },
  { label: "Window & Facade", slug: "window-facade-cleaning" },
  { label: "Pressure Washing", slug: "pressure-cleaning" }
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_industrial-clean-pro/artifacts/5o9nd5tr_PKC%20Property%20Services%20Pty%20Ltd_E2.jpeg"
              alt="PKC Property Services"
              className="h-36 md:h-44 w-auto mb-4"
            />
            <p className="text-neutral-500 text-sm leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Commercial cleaning specialists serving Melbourne's construction industry since 2022.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-neutral-900 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Navigation
            </h4>
            <ul className="space-y-2">
              {FOOTER_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-neutral-500 text-sm hover:text-[#B8D86B] transition-colors duration-200"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-neutral-900 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Services
            </h4>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services#${s.slug}`}
                    className="text-neutral-500 text-sm hover:text-[#B8D86B] transition-colors duration-200"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-neutral-900 mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#B8D86B] mt-0.5 shrink-0" />
                <span className="text-neutral-500 text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>Melbourne, VIC</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-[#B8D86B] mt-0.5 shrink-0" />
                <a href="tel:0391149576" className="text-neutral-500 text-sm hover:text-[#B8D86B] transition-colors" style={{ fontFamily: 'Manrope, sans-serif' }}>(03) 9114 9576</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-[#B8D86B] mt-0.5 shrink-0" />
                <a href="mailto:admin@pkcpropertyservices.com.au" className="text-neutral-500 text-sm hover:text-[#B8D86B] transition-colors whitespace-nowrap" style={{ fontFamily: 'Manrope, sans-serif' }}>admin@pkcpropertyservices.com.au</a>
              </li>
              <li className="flex items-start gap-2">
                <Linkedin className="w-4 h-4 text-[#B8D86B] mt-0.5 shrink-0" />
                <a href="https://au.linkedin.com/company/pkc-property-services" target="_blank" rel="noopener noreferrer" className="text-neutral-500 text-sm hover:text-[#B8D86B] transition-colors" style={{ fontFamily: 'Manrope, sans-serif' }}>LinkedIn</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-neutral-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-neutral-400 text-xs" style={{ fontFamily: 'Manrope, sans-serif' }}>
            &copy; {new Date().getFullYear()} PKC Property Services. All rights reserved.
          </p>
          <p className="text-neutral-400 text-xs" style={{ fontFamily: 'Manrope, sans-serif' }}>
            ABN: 20 663 818 826
          </p>
        </div>
      </div>
    </footer>
  );
};
